// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overview-module__resultOverviewContainer___ttazY {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 0;
    min-height: 180px;
}

.Overview-module__circleContainer___yWQ_d {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 0 40px;
    gap: 20px;
}

.Overview-module__circleContainer___yWQ_d.Overview-module__cols1___ZvVxW {
    grid-template-columns: 1fr;
}

.Overview-module__circleContainer___yWQ_d.Overview-module__cols2___PvBT7 {
    grid-template-columns: repeat(2, 1fr);
}

.Overview-module__circleContainer___yWQ_d.Overview-module__cols3___J_G5z {
    grid-template-columns: repeat(3, 1fr);
}

.Overview-module__circleAndTextContainer___CW40A {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    gap: 8px;
}

.Overview-module__circle___kMtJv {
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    background-color: #d9d9d9;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.Overview-module__circleWithText___kgr6W {
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.Overview-module__circleWithText___kgr6W,
.Overview-module__circle___kMtJv {
    background-color: #e5e7eb;
    border: 1px solid #e5e7eb;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    transform-style: preserve-3d;
    transition: transform 0.3s ease;
}

.Overview-module__circleImage___AaoXH {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.Overview-module__circleText___kEbjh {
    font-size: 25px;
    color: white;
    font-weight: bold;
    text-align: center;
}

.Overview-module__smallText___Fy6hd {
    font-size: 13px;
}

.Overview-module__circleDescription___KTa79 {
    margin-top: 8px;
    font-size: 20px;
    text-align: center;
    color: black;
    font-weight: bold;
    word-wrap: break-word;
    max-width: 120px;
}

.Overview-module__circleDescriptionMultiline___k7ZRW {
    position: absolute;
    top: 63%;
    left: 50%;
    transform: translateX(-50%);
    max-width: none;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
}

.Overview-module__productPromiseColor___mQDol {
    background-color: var(--bmo-primary-color-lavender);
}

.Overview-module__deliveredColor___i7SoY {
    background-color: #6dc248;
}

.Overview-module__notDeliveredColor___OL_fk {
    background-color: #e52c1a;
}

.Overview-module__notCompletedColor___GEpcr {
    background-color: #808080;
}

.Overview-module__notStartedColor___wojdj {
    background-color: var(--bmo-primary-color-mint);
}

@media (max-width: 768px) {
    .Overview-module__circle___kMtJv,
    .Overview-module__circleWithText___kgr6W {
        width: 80px;
        height: 80px;
        min-width: 80px;
        min-height: 80px;
    }

    .Overview-module__circleText___kEbjh {
        font-size: 20px;
    }

    .Overview-module__circleDescription___KTa79 {
        font-size: 16px;
        max-width: 100px;
    }
}

@media (max-width: 480px) {
    .Overview-module__circleContainer___yWQ_d,
    .Overview-module__circleContainer___yWQ_d.Overview-module__cols1___ZvVxW,
    .Overview-module__circleContainer___yWQ_d.Overview-module__cols2___PvBT7,
    .Overview-module__circleContainer___yWQ_d.Overview-module__cols3___J_G5z {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .Overview-module__resultOverviewContainer___ttazY {
        min-height: 160px;
    }

    .Overview-module__circleDescription___KTa79 {
        max-width: 150px;
    }
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/SummaryPage/Overview/Overview.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,sGAAsG;IACtG,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI;;QAEI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;;;;QAII,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".resultOverviewContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 20px 0;\n    min-height: 180px;\n}\n\n.circleContainer {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 0 40px;\n    gap: 20px;\n}\n\n.circleContainer.cols1 {\n    grid-template-columns: 1fr;\n}\n\n.circleContainer.cols2 {\n    grid-template-columns: repeat(2, 1fr);\n}\n\n.circleContainer.cols3 {\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.circleAndTextContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    gap: 8px;\n}\n\n.circle {\n    width: 100px;\n    height: 100px;\n    min-width: 100px;\n    min-height: 100px;\n    background-color: #d9d9d9;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n}\n\n.circleWithText {\n    width: 100px;\n    height: 100px;\n    min-width: 100px;\n    min-height: 100px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n}\n\n.circleWithText,\n.circle {\n    background-color: #e5e7eb;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease;\n}\n\n.circleImage {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.circleText {\n    font-size: 25px;\n    color: white;\n    font-weight: bold;\n    text-align: center;\n}\n\n.smallText {\n    font-size: 13px;\n}\n\n.circleDescription {\n    margin-top: 8px;\n    font-size: 20px;\n    text-align: center;\n    color: black;\n    font-weight: bold;\n    word-wrap: break-word;\n    max-width: 120px;\n}\n\n.circleDescriptionMultiline {\n    position: absolute;\n    top: 63%;\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: none;\n    white-space: nowrap;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.productPromiseColor {\n    background-color: var(--bmo-primary-color-lavender);\n}\n\n.deliveredColor {\n    background-color: #6dc248;\n}\n\n.notDeliveredColor {\n    background-color: #e52c1a;\n}\n\n.notCompletedColor {\n    background-color: #808080;\n}\n\n.notStartedColor {\n    background-color: var(--bmo-primary-color-mint);\n}\n\n@media (max-width: 768px) {\n    .circle,\n    .circleWithText {\n        width: 80px;\n        height: 80px;\n        min-width: 80px;\n        min-height: 80px;\n    }\n\n    .circleText {\n        font-size: 20px;\n    }\n\n    .circleDescription {\n        font-size: 16px;\n        max-width: 100px;\n    }\n}\n\n@media (max-width: 480px) {\n    .circleContainer,\n    .circleContainer.cols1,\n    .circleContainer.cols2,\n    .circleContainer.cols3 {\n        grid-template-columns: 1fr;\n        gap: 30px;\n    }\n\n    .resultOverviewContainer {\n        min-height: 160px;\n    }\n\n    .circleDescription {\n        max-width: 150px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultOverviewContainer": `Overview-module__resultOverviewContainer___ttazY`,
	"circleContainer": `Overview-module__circleContainer___yWQ_d`,
	"cols1": `Overview-module__cols1___ZvVxW`,
	"cols2": `Overview-module__cols2___PvBT7`,
	"cols3": `Overview-module__cols3___J_G5z`,
	"circleAndTextContainer": `Overview-module__circleAndTextContainer___CW40A`,
	"circle": `Overview-module__circle___kMtJv`,
	"circleWithText": `Overview-module__circleWithText___kgr6W`,
	"circleImage": `Overview-module__circleImage___AaoXH`,
	"circleText": `Overview-module__circleText___kEbjh`,
	"smallText": `Overview-module__smallText___Fy6hd`,
	"circleDescription": `Overview-module__circleDescription___KTa79`,
	"circleDescriptionMultiline": `Overview-module__circleDescriptionMultiline___k7ZRW`,
	"productPromiseColor": `Overview-module__productPromiseColor___mQDol`,
	"deliveredColor": `Overview-module__deliveredColor___i7SoY`,
	"notDeliveredColor": `Overview-module__notDeliveredColor___OL_fk`,
	"notCompletedColor": `Overview-module__notCompletedColor___GEpcr`,
	"notStartedColor": `Overview-module__notStartedColor___wojdj`
};
export default ___CSS_LOADER_EXPORT___;
